<template>
  <div v-if="visible" class="dialog">
    <div class="content">
      <h3>{{ title }}</h3>
      <p>{{ message }}</p>
      <div class="btn-group btn-group-justified" role="group" aria-label="...">
        <div v-if="showCancel" class="btn-group" role="group">
          <button @click="$emit('cancel')" type="button" class="btn btn-default">
            {{ cancelButtonText }}
          </button>
        </div>
        <div class="btn-group" role="group">
          <button @click="$emit('ok')" type="button" class="btn btn-primary">
            {{ okButtonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    title: String,
    message: String,
    showCancel: {
      type: Boolean,
      default: true
    },
    okButtonText: {
      type: String,
      default: "OK"
    },
    cancelButtonText: {
      type: String,
      default: "Abbrechen"
    }
  }
};
</script>

<style scoped>
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(2px);
  display: flex;
  z-index: 10;
}

.dialog .content {
  background: white;
  border-radius: 1rem;
  padding: 1rem 3rem 3rem 3rem;
  width: 100%;
  max-width: 480px;
  margin: auto;
}

.dialog p {
  margin-bottom: 2rem;
}
</style>
